import { CheckStatus, Parse } from '../utils/ajax';

const createSnapshot = (token, tenantId, flowId) => {

    const url = `/api/draw/1/flow/snap/${flowId}`;

    const request = {
        headers: {
            Authorization: token,
            ManyWhoTenant: tenantId,
        },
        method: 'POST',
    };

    return fetch(url, request)
        .then(CheckStatus)
        .then(Parse);
}

export default createSnapshot;
